var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lab-form-divider"},[_c('div',{staticClass:"lab-form-divider--title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"lab-form-divider__append"},[_vm._t("append")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }